<template>
  <v-card flat min-height="100">

    <v-row class="mx-auto fill-height" no-gutters justify="start">
      <critical-dataset-belt-detector :belt-entry="beltEntry" @filter-value-changed="passFilterChanges"
                                      :is-filter="isFilter"></critical-dataset-belt-detector>
      <critical-dataset-hands-frame-detector :hands-frame-entry="handsFrameEntry"
                                             @filter-value-changed="passFilterChanges"
                                             :is-filter="isFilter"></critical-dataset-hands-frame-detector>
    </v-row>

    <critical-dataset-phone-detector :phone-entry="phoneEntry" @filter-value-changed="passFilterChanges"
                                     :is-filter="isFilter"></critical-dataset-phone-detector>

    <v-row class="mx-auto fill-height" no-gutters justify="start">
      <critical-dataset-food-detector :food-entry="foodEntry" @filter-value-changed="passFilterChanges"
                                      :is-filter="isFilter"></critical-dataset-food-detector>
      <critical-dataset-smoke-detector :smoke-entry="smokeEntry" @filter-value-changed="passFilterChanges"
                                       :is-filter="isFilter"></critical-dataset-smoke-detector>
    </v-row>

  </v-card>
</template>

<script>
import { mdiCellphone, mdiFood, mdiHandRight, mdiSeatbelt, mdiSmoking } from '@mdi/js'
import {
  CriticalDatasetLabels,
  DetectorDirection,
  DetectorFoodDrink,
  DetectorFoodEat,
  DetectorSmokeDirection
} from '../../../enum'
import { DetectorBeltEntry } from '../../../models/criticalDataset/DetectorBeltEntry'
import { DetectorPhoneEntry } from '../../../models/criticalDataset/DetectorPhoneEntry'
import { DetectorFoodEntry } from '../../../models/criticalDataset/DetectorFoodEntry'
import { DetectorSmokeEntry } from '../../../models/criticalDataset/DetectorSmokeEntry'
import { DetectorFrameHands } from '../../../models/criticalDataset/DetectorFrameHands'
import CriticalDatasetBeltDetector from './criticalDatasetBeltDetector'
import CriticalDatasetHandsFrameDetector from './criticalDatasetHandsFrameDetector'
import CriticalDatasetPhoneDetector from './criticalDatasetPhoneDetector'
import CriticalDatasetFoodDetector from './criticalDatasetFoodDetector'
import CriticalDatasetSmokeDetector from './criticalDatasetSmokeDetector'

const beltIcon = mdiSeatbelt
const cellphoneIcon = mdiCellphone
const eatingIcon = mdiFood
const smokingIcon = mdiSmoking
const handsIcon = mdiHandRight

export default {
  name: 'criticalDatasetDetector',
  components: {
    CriticalDatasetSmokeDetector,
    CriticalDatasetFoodDetector,
    CriticalDatasetPhoneDetector,
    CriticalDatasetHandsFrameDetector,
    CriticalDatasetBeltDetector
  },
  props: {
    beltEntry: DetectorBeltEntry,
    phoneEntry: DetectorPhoneEntry,
    foodEntry: DetectorFoodEntry,
    smokeEntry: DetectorSmokeEntry,
    handsFrameEntry: DetectorFrameHands,
    isFilter: Boolean
  },
  data: () => ({
    directionList: Object.values(DetectorDirection),
    eatList: Object.values(DetectorFoodEat),
    drinkList: Object.values(DetectorFoodDrink),
    smokeList: Object.values(DetectorSmokeDirection),

    beltIcon: beltIcon,
    cellphoneIcon: cellphoneIcon,
    eatingIcon: eatingIcon,
    smokingIcon: smokingIcon,
    handsIcon: handsIcon
  }),
  methods: {
    passFilterChanges (data) {
      this.$emit('filter-value-changed', data)
    }
  },
  created () {
    this['CriticalDatasetLabels'] = CriticalDatasetLabels
    this['DetectorDirection'] = DetectorDirection
  }
}
</script>

<style scoped>

</style>
